import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
import { Home, Replay } from '@material-ui/icons';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Button, Typography, Container } from '@material-ui/core';
// components
import { MotionContainer, varBounceIn } from '../components/animate';
import Logo from '../components/Logo';
import Page from '../components/Page';


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: { padding: theme.spacing(5, 5, 0) }
}));

// ----------------------------------------------------------------------

export default function PageError(props) {

  const {errorClick} = props;




  return (
    <RootStyle title="Error">
      <HeaderStyle>
        <RouterLink to="/">
          <Logo />
        </RouterLink>
      </HeaderStyle>

      <Container>
        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 900, margin: 'auto', textAlign: 'center' }}>
            <motion.div variants={varBounceIn}>
              <Typography variant="h3" gutterBottom>
                An error has happened, we’re very sorry.
              </Typography>
            </motion.div>
            <Typography sx={{ color: 'text.secondary' }}>
              Sorry, there has been an error in the application. Our team has been notified of the problem.<br/>
              Please either try again or contact support who will help you resolve the issue. <br/><br/>
              You can open a support ticket at <a rel="noreferrer" target="_blank" href="https://support.i-gtm.com">https://support.i-gtm.com</a> or email <a rel="noreferrer" target="_blank" href="mailto:support@i-gtm.com">support@i-gtm.com</a>.
            </Typography>
            <Box sx={{mt:2}}>
            <Button
                size="large"
                onClick={()=>{
                  // errorClick()
                  window.location.reload();
                }}
                startIcon={<Replay/>}
                variant="contained"
                sx={{margin:3}}
              >
                Try Again
              </Button>
              <Button
                size="large"
                onClick={()=>{
                  window.location.href = '/app';
                }}
                startIcon={<Home/>}
                variant="contained"
                component={RouterLink}
              >
                Return to your dashboard
              </Button>
            </Box>
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
}
